<template>
    <form @submit.prevent="handleSubmit" class="mb-4">
        <h3 class="is-size-6 mb-3">Información Empresa</h3>
        <b-field label="Razón Social" label-position="on-border">
            <b-input
                v-model="empresa.razon_social"
                name="razon_social"
                @input="
                    empresa.razon_social = empresa.razon_social.toUpperCase()
                "
                required
            ></b-input>
        </b-field>
        <b-field label="RUC" label-position="on-border">
            <b-input
                v-model="empresa.ruc"
                name="ruc"
                v-cleave="masks.ruc"
                required
            ></b-input>
        </b-field>
        <autocomplete-paises
            v-model="empresa.pais_id"
            required
        />
        <b-field label="Dirección (opcional)" label-position="on-border">
            <b-input v-model="empresa.direccion" name="direccion"></b-input>
        </b-field>
        <br />
        <b-message type="is-primary">
            Se le asignará
            <b class="has-text-primary">por defecto el Perfil Administrador</b>.
        </b-message>
        <h3 class="is-size-6 mb-3">Información Usuario</h3>
        <b-field label="Username" label-position="on-border">
            <b-input
                :value="perfil.trabajador.usuario.username"
                name="username"
                disabled
            ></b-input>
        </b-field>
        <b-field label="Email" label-position="on-border">
            <b-input
                :value="perfil.trabajador.usuario.email"
                name="email"
                disabled
            ></b-input>
        </b-field>
        <b-field label="Pais" label-position="on-border">
            <b-input
                :value="perfil.trabajador.usuario.persona.pais.descripcion"
                name="pais"
                disabled
            ></b-input>
        </b-field>
        <b-field label="Nombre" label-position="on-border">
            <b-input
                v-model="trabajador.nombre"
                name="nombre"
                @input="trabajador.nombre = trabajador.nombre.toUpperCase()"
                required
            ></b-input>
        </b-field>
        <b-field label="Apellido Paterno" label-position="on-border">
            <b-input
                v-model="trabajador.apellido_paterno"
                name="apellido_paterno"
                @input="
                    trabajador.apellido_paterno =
                        trabajador.apellido_paterno.toUpperCase()
                "
                required
            ></b-input>
        </b-field>
        <b-field label="Apellido Materno" label-position="on-border">
            <b-input
                v-model="trabajador.apellido_materno"
                name="apellido_materno"
                @input="
                    trabajador.apellido_materno =
                        trabajador.apellido_materno.toUpperCase()
                "
                required
            ></b-input>
        </b-field>
        <b-field label="Dirección (opcional)" label-position="on-border">
            <b-input v-model="trabajador.direccion" name="direccion"></b-input>
        </b-field>
        <b-button
            v-if="buttonEnabled"
            type="is-primary"
            native-type="submit"
            expanded
        >
            Continuar
        </b-button>
    </form>
</template>

<script>
import EmpresaForm from '@/components/Empresa/EmpresaForm.vue';
import AutocompletePaises from '@/components/shared/FormControls/AutocompletePaises.vue';

export default {
    name: 'RegisterDataForm',
    props: {
        empresa: Object,
        trabajador: Object,
        buttonEnabled: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        EmpresaForm,
        AutocompletePaises,
    },
    data() {
        return {
            masks: {
                ruc: {
                    blocks: [11],
                    numericOnly: true,
                },
            },
        };
    },
    computed: {
        perfil() {
            return this.$store.state.me.perfil;
        },
    },
    methods: {
        hasEmptyFields(object) {
            for (const key in object) {
                const element = object[key];
                if (!element && key !== 'direccion') {
                    return false;
                }
            }
            return true;
        },
        handleSubmit() {
            this.$emit('submit');
        }
    },
};
</script>

<style>
</style>
